import axios from '@/axios';

const state = {
    isLoading: false,
    currencies: [],
    currency: localStorage.getItem("currency"),
    settings: {},
    paymentMethods: [],
    internalCurrency: null,
    minTopUp: 0,
    maxTopUp: null,
}

const getters = {
    currency: state => state.currency,
    currencySymbol: ({currencies, currency}) => {
        if (currency) {
            const curr = currencies.find(({id}) => currency === id);

            if (curr) {
                return curr.symbol;
            }
        }

        return '';
    },
    currencyRate: ({currencies, currency}) => {
        if (!currency) return 1;

        const curr = currencies.find(({id}) => currency === id);

        return curr && curr.value ? parseFloat(curr.value) : 1;
    },
    settings: state => state.settings,
    paymentMethods: state => state.paymentMethods,
    availablePaymentMethods: state => {
        return (state.paymentMethods || []).filter((method) => {
            return (
                !method.currencies ||
                !method.currencies.length ||
                method.currencies.includes(state.currency)
            );
        });
    },
    footerPaymentImages: state => {
        return (state.paymentMethods || []).reduce((images, method) => {
            if (method.footer_images && method.footer_images.length) {
                return images.concat(method.footer_images);
            }

            if (method.image) {
                images.push({
                    url: method.image,
                    height: 25,
                });
            }

            return images;
        }, []);
    },
    internalCurrency: state => state.internalCurrency,
    internalCurrencyEnabled: state => Boolean(state.internalCurrency && state.internalCurrency.enabled),
    displayCurrencySymbol: (state, getters) => {
        return getters.internalCurrencyEnabled
            ? state.internalCurrency.symbol
            : getters.currencySymbol;
    },
    minTopUp: state => state.minTopUp,
    maxTopUp: state => state.maxTopUp,
}

const actions = {
    fetchCurrencies: async ({commit},) => {
        try {
            commit('setLoading', true);
            const {data: {status, payload}} = await axios.get(process.env.VUE_APP_API + 'currencies');
            if (status === 'OK') {
                const currencies = payload.map(({code: text, symbol, value}) => ({text, id: text, symbol, value}));
                commit('setCurrencies', currencies);

                if (localStorage.getItem("currency")) {
                    commit('setCurrency', localStorage.getItem("currency"));
                } else {
                    commit('setCurrency', currencies[0].text);
                }
            }
        } catch (e) {
            console.log(e);
        } finally {
            commit('setLoading', false);
        }
    },
    fetchSettings: async ({commit, state}) => {
        const {data: {status, payload}} = await axios.get(process.env.VUE_APP_API + 'settings', {
            params: {currency: state.currency}
        });

        if (status === 'OK') {
            commit('setSettings', payload || {});
        }

        return payload || {};
    },
    // changeCurrency: async ({commit, getters}, lcurrency) => {
    //     if (localeId) {
    //         commit('setCurrentLanguage', localeId);
    //
    //         try {
    //             const {data} = await axios.get('/localizations', {
    //                 params: {
    //                     lang_id: localeId
    //                 }
    //             });
    //
    //             if (data) {
    //                 let translations = {};
    //
    //                 if (Array.isArray(data) && data.length) {
    //                     data.forEach((translation) => translations[Object.keys(translation)[0]] = Object.values(translation)[0])
    //                 } else if (typeof data === 'object') {
    //                     translations = data;
    //                 }
    //
    //                 const {currentLanguageCode} = getters;
    //
    //                 i18n.setLocaleMessage(currentLanguageCode, translations)
    //                 i18n.locale = currentLanguageCode;
    //             }
    //         } catch (e) {
    //             console.log(e);
    //         }
    //     }
    // },
    // checkCurrency: async ({commit}) => {
    //
    // }
}

const mutations = {
    setLoading: (state, loading) => (state.isLoading = loading),
    setCurrencies: (state, currencies) => (state.currencies = currencies),
    setSettings: (state, settings) => {
        state.settings = settings || {};
        state.paymentMethods = state.settings.payment_methods || [];
        state.internalCurrency = state.settings.internal_currency || null;
        state.minTopUp = state.settings.min_top_up || 0;
        state.maxTopUp = state.settings.max_top_up || null;
    },
    setCurrency: (state, currency) => {
        console.log('Set currency');
        localStorage.setItem('currency', currency);
        state.currency = currency;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
